// extracted by mini-css-extract-plugin
export default {"icon":"EditIcon-module-ba2a711ec55deb7dcdb6"};